export enum commongameAssetConfig {
    commongamePotraitBG = "assets/commongame/portraitbasegame_bg.jpg",
    commongamePotraitFG = "assets/commongame/portraitfreegame_bg.jpg",
    baseGameBgImage = "assets/commongame/basegame_bg.jpg",

    freeGameBgImage = "assets/commongame/fg_bg.jpg",
    //   freeGameBgTopImage = "assets/commongame/fg_bg_back.jpg",


    Base_game_vines = "assets/basegame/basegame.json",
    Free_game_vines = "assets/freegame/freegame.json",

}